import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const StyledPaginatorWrapper = styled.div`
  /* width: ${rem('70px')}; */
  text-align: center;
`;

const StyledpaginatorText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('12px')};
  color: ${props => props.theme.colors.grayDark};
`;

const StyledBtnArrow = styled.button`
  background: none;
  border: none;
  width: ${rem('5px')};
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;

const StyledArrow = styled.div`
  background: none;
  border: none;
  width: ${rem('5px')};
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const StyledIcon = styled(Icon)`
  transform: rotate(-90deg);
  width: ${rem('5px')};
  height: ${rem('9px')};
`;

const StyledIconBot = styled(StyledIcon)`
  position: relative;
  top: ${rem('-5px')};
`;

export {
  StyledPaginatorWrapper,
  StyledpaginatorText,
  StyledBtnArrow,
  StyledIcon,
  StyledIconBot,
  StyledArrow
};
